export default __webpack_public_path__ + "static/media/juice.1cd1e03d.png";